class ProductImagesSlider extends HTMLElement {
  constructor(currentVarName, productName) {
    super();
    var $sliderMain = $('.slider.slider-for');
    var $navSlider = $('.slider.slider-nav');
    var $highlight = $('.slider-highlight');


    if (!$sliderMain) {
      return;
    } else {

      const optionsMain = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        asNavFor: '.slider-nav',
        dots: false,
        infinite: false,
        adaptiveHeight: true,
        prevArrow: '<button class="slick-arrow previous"><svg class="slider-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow"></path></svg></button>',
        nextArrow: '<button class="slick-arrow next"><svg class="slider-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
        cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
        speed: 750,
        responsive: [
          {
            breakpoint: 991,
            settings: {
                slidesToShow: 1
            }
          },
          {
            breakpoint: 750,
            settings: {
              dots: false,
              slidesToShow: 1
            }
          }
        ],
      };

      if (currentVarName !== undefined && productName !== undefined) {
        if (!$sliderMain[0].classList.contains('slick-initialized')) {
          $sliderMain.slick(optionsMain);
        }

        $sliderMain.slick('slickUnfilter');
        $sliderMain.slick('slickFilter', '[data-alt="' + currentVarName + '"], [data-alt="' + productName + '"], [data-alt^="*"]');
      } else {
        $sliderMain.slick(optionsMain);
      }
    }

    if ($navSlider) {

      const optionsNav = {
        slidesToShow: 5,
        draggable: false,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        asNavFor: '.slider-for',
        focusOnSelect: true,
        centerMode: false,
        infinite: false,
        adaptiveHeight: true,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 750,
            settings: {
              dots: true
            }
          }
        ]
      };

      if (currentVarName !== undefined && productName !== undefined) {
        if (!$navSlider[0].classList.contains('slick-initialized')) {
          $navSlider.slick(optionsNav);
        }

        $navSlider.slick('slickUnfilter');
        $navSlider.slick('slickFilter', '[data-alt="' + currentVarName + '"], [data-alt="' + productName + '"], [data-alt^="*"]');
        $navSlider.find('.slick-slide').removeAttr('aria-hidden');
        // Scroll to the current variant
        this.updateHighlight($navSlider);
      } else {
        $navSlider.slick(optionsNav);
      }

      // Add event listener for slider change
      $sliderMain.on('afterChange', (event, slick, currentSlide) => {
        const $currentSlide = $(slick.$slides[currentSlide]);
        const slickIndex = $currentSlide.attr('data-slick-index');
        this.updateHighlight($navSlider, slickIndex);
      });
    }

    $(window).resize(function () {
      if ($sliderMain) { $sliderMain.slick('resize'); }
      if ($navSlider) { $navSlider.slick('resize'); }
    });
  }

  updateHighlight($navSlider, slickIndex) {
    const $currentThumb = $navSlider.find(`[data-slick-index="${slickIndex}"]`);

    if ($currentThumb.length) {
      const highlightTop = $currentThumb.position().top;
      $('.slider-highlight').css('top', highlightTop);

      // Scroll the nav slider
      const $sliderContainer = $navSlider.closest('.slider-nav__container');
      if ($sliderContainer.length) {
        // Recalculate startPosition dynamically
        const startPosition = $sliderContainer.scrollTop();
        const thumbOffset = $currentThumb.offset().top; // Get the offset relative to the document
        const containerOffset = $sliderContainer.offset().top; // Get the container's offset
        const thumbHeight = $currentThumb.outerHeight();
        const containerHeight = $sliderContainer.height();

        // Get the total number of slides
        const totalSlides = $navSlider.find('[data-slick-index]').length;

        // Calculate the number of slides that can fit in the container
        const slidesInView = Math.floor(containerHeight / thumbHeight);

        // Define a constant for the offset
        const lastSlideOffset = 2; // Change this value to adjust when to trigger the scroll

        // Calculate the target position to ensure the thumbnail is in view
        let targetPosition = thumbOffset - containerOffset;

        // Determine if we need to scroll up or down
        if (totalSlides > slidesInView) { // Only adjust if there are more slides than can fit
          if (slickIndex >= totalSlides - slidesInView - lastSlideOffset) { // Use the constant here
            // If the clicked thumbnail is within the last few slides
            const remainingSlidesHeight = (totalSlides - slickIndex) * thumbHeight; // Assuming equal height for each slide
            targetPosition = Math.max(0, targetPosition - remainingSlidesHeight + containerHeight);
          } else if (slickIndex < slidesInView) {
            // If the clicked thumbnail is within the first few slides
            targetPosition = Math.min(targetPosition + (thumbHeight / 2) - (containerHeight / 2), targetPosition);
          } else {
            // Center the highlight for other slides
            targetPosition += (thumbHeight / 2) - (containerHeight / 2);
          }
        }

        // Check if the clicked thumbnail is the first item of the second page
        if (slickIndex === slidesInView) {
          // Scroll down to ensure the first item of the second page is fully visible
          targetPosition = Math.max(0, targetPosition - thumbHeight);
        }

        // Get the maximum scroll position
        const maxScrollPosition = $sliderContainer[0].scrollHeight - containerHeight;

        // Clamp the target position to ensure it stays within bounds
        const clampedTargetPosition = Math.max(0, Math.min(targetPosition, maxScrollPosition));

        // Calculate the distance from the current scroll position to the target position
        const distance = clampedTargetPosition - startPosition;

        // Smooth scrolling logic
        const duration = 300;
        const startTime = performance.now();

        function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        }

        function step(currentTime) {
          const elapsed = currentTime - startTime;
          if (elapsed < duration) {
            const progress = easeInOutQuad(elapsed / duration);
            $sliderContainer.scrollTop(startPosition + distance * progress);
            requestAnimationFrame(step);
          } else {
            // Ensure we reach the final position
            $sliderContainer.scrollTop(clampedTargetPosition);
          }
        }

        // Start the smooth scrolling animation
        requestAnimationFrame(step);
      }
    }
  }
}

customElements.define('product-images-slider', ProductImagesSlider);